import { getAwsAssets } from "@src/utils/index";
import { CONTENT_TYPE } from "../store/constants";

const getAwsAssetThumbnail = (name) => {
  return getAwsAssets(`${name}Thumbnail.svg`, "content");
};

const getContentThumbnail = ({
  contentType,
  thumbnailUrl,
  format,
  url,
  typeOfTest,
}) => {
  switch (contentType) {
    case CONTENT_TYPE.FOLDER:
      return getAwsAssetThumbnail("folder");
    case CONTENT_TYPE.LIVE_CLASS:
    case CONTENT_TYPE.VIDEO:
      return thumbnailUrl && thumbnailUrl !== "undefined"
        ? thumbnailUrl
        : getAwsAssetThumbnail("default"); // video file
    case CONTENT_TYPE.DOCUMENT:
      if (["jpg", "png", "jpeg"].includes(format) && (url && url !== "undefined")) {
        return url;
      }
      else {
        const payloadFormat = ["jpg", "png", "jpeg"].includes(format) ? "default" : format;
        return getAwsAssetThumbnail(payloadFormat);
      }
    case CONTENT_TYPE.PRACTICE_TEST:
      return getAwsAssetThumbnail("subjectiveTest");
    case CONTENT_TYPE.TEST:
      switch (typeOfTest) {
        case 0:
          return getAwsAssetThumbnail("onlineTest");
        case 1:
          return getAwsAssetThumbnail("subjectiveTest");
        case 2:
          return getAwsAssetThumbnail("onlineTest");
        default:
          return getAwsAssetThumbnail("onlineTest");
      }
  }
};

export default getContentThumbnail;
